'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.triplePut = exports.TRIPLE_PUT = exports.tripleDel = exports.TRIPLE_DEL = exports.entityUpdate = exports.ENTITY_UPDATE = exports.entityPutAll = exports.ENTITY_PUTALL = exports.entityPutRaw = exports.entityPut = exports.ENTITY_PUT = exports.entityDel = exports.ENTITY_DEL = undefined;

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.entityUpdateFields = entityUpdateFields;

var _capeRedux = require('cape-redux');

var _helpers = require('./helpers');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ENTITY_DEL = exports.ENTITY_DEL = 'graph/ENTITY_DEL';
var entityDel = exports.entityDel = (0, _capeRedux.createAction)(ENTITY_DEL, _helpers.requireIdType);
var ENTITY_PUT = exports.ENTITY_PUT = 'graph/ENTITY_PUT';
var entityPut = exports.entityPut = (0, _capeRedux.createAction)(ENTITY_PUT, _helpers.insertFields);
var entityPutRaw = exports.entityPutRaw = (0, _capeRedux.createAction)(ENTITY_PUT);
var ENTITY_PUTALL = exports.ENTITY_PUTALL = 'graph/ENTITY_PUTALL';
var entityPutAll = exports.entityPutAll = (0, _capeRedux.createAction)(ENTITY_PUTALL, function (values) {
  if (!(0, _isArray3.default)(values)) throw new Error('Must send putAll an array.');
  return (0, _map3.default)(values, _helpers.insertFields);
});
var ENTITY_UPDATE = exports.ENTITY_UPDATE = 'graph/ENTITY_UPDATE';
var entityUpdate = exports.entityUpdate = (0, _capeRedux.createAction)(ENTITY_UPDATE, _helpers.updateFields);

function entityUpdateFields(entity, fields) {
  return entityUpdate(_extends({}, (0, _helpers.requireIdType)(entity), fields));
}

var TRIPLE_DEL = exports.TRIPLE_DEL = 'graph/TRIPLE_DEL';
var tripleDel = exports.tripleDel = (0, _capeRedux.createAction)(TRIPLE_DEL, _helpers.buildTripleDel);
var TRIPLE_PUT = exports.TRIPLE_PUT = 'graph/TRIPLE_PUT'; // You send it an object with an id, object, subject and predicate properties.
// This is only used when there a multiple predicate refs.

var triplePut = exports.triplePut = (0, _capeRedux.createAction)(TRIPLE_PUT, _helpers.buildTriple);